import { Injectable } from '@angular/core';
import { BaseApiClientRisksService } from './base-api-client-risks.service';

@Injectable({
  providedIn: 'root'
})
export class ApiClientRisksService extends BaseApiClientRisksService {}
